<div class="burger-menu-container">
  <!-- Burger Menu Button -->
  <button class="burger-menu-button" (click)="toggleMenu()" type="button">
    <img src="/assets/images/menu.png" alt="Menu" class="burger-icon">
  </button>

  <!-- Dropdown Menu -->
  <div class="burger-menu" [class.show]="isMenuOpen">
    <div class="menu-items">
      <!-- CGP Books Link -->
      @if (!isPupilMember) {
        <button class="menu-item" (click)="navigateToCGPBooks()">
          CGP Books
        </button>
      }

      @if (routeContext !== 'eleven-plus') {
        <!-- CGP RevisionHub Link -->
        <button class="menu-item" (click)="navigateToRevisionHub()">
          CGP RevisionHub
        </button>
      }

      <!--11+-->
      @if (routeContext === 'eleven-plus') {
        <button class="menu-item" (click)="navigateToElevenPlusDashboard()">
          Dashboard
        </button>
        @if (!isPupilMember) {
          <button class="menu-item" (click)="navigateToElevenPlusChangeUser()">
            Change User
          </button>
        }
      }

      <!-- Login/Logout -->
      @if (!isLoggedIn()) {
        <a class="menu-item" routerLink="/login" routerLinkActive="active" (click)="isMenuOpen = false">
          Sign In
        </a>
      }
      @if (isLoggedIn()) {
        <button class="menu-item" (click)="logout()">
          Sign Out
        </button>
      }
    </div>
  </div>
</div>

